export default {"src":"/_next/static/media/arrow-down-new.1d9e77f3.svg","height":9,"width":16};